import { ADD_CUSTOM_FIELD, DELETE_CUSTOM_FIELD, SET_CUSTOM_FIELD_INITIAL_DATA, SET_CUSTOM_FIELD_LOADING, SET_CUSTOM_FIELDS, } from "../constants";
const reducer = (state, action) => {
    switch (action.type) {
        case SET_CUSTOM_FIELD_LOADING: {
            const loading = action.payload;
            return Object.assign(Object.assign({}, state), { loading });
        }
        case SET_CUSTOM_FIELD_INITIAL_DATA: {
            const { entityId, entityType } = action.payload;
            return Object.assign(Object.assign({}, state), { entityId,
                entityType });
        }
        case SET_CUSTOM_FIELDS: {
            const customFields = action.payload;
            return Object.assign(Object.assign({}, state), { customFields });
        }
        case ADD_CUSTOM_FIELD: {
            const customField = action.payload;
            return Object.assign(Object.assign({}, state), { customFields: [...state.customFields, customField] });
        }
        case DELETE_CUSTOM_FIELD: {
            const customFieldId = action.payload;
            const customFields = state.customFields.filter((customField) => customField.id !== customFieldId);
            return Object.assign(Object.assign({}, state), { customFields });
        }
        default: {
            return state;
        }
    }
};
export { reducer };
